import { IRole } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface IUpdateRoleRequest {
  slug: string;
  name: string;
  description: string | null;
  permissions: string[];
}

export const updateRole = async ({ slug, ...role }: IUpdateRoleRequest): Promise<IRole> => {
  const response = await fetch(`${API_URL}/admin/roles/${slug}`, {
    method: 'PATCH',
    body: JSON.stringify(role),
  });

  if (!response.ok) {
    const responseBody = await response.json().catch(() => null);
    throw new Error(responseBody?.message || 'Could not update role');
  }

  const responseBody = await response.json();
  return responseBody.data;
};
